import React, { SyntheticEvent } from 'react';
import { Form, Input } from '../form';

interface Props {
  handleChange: (e: React.FormEvent<HTMLInputElement>) => void;
  onSubmit: (e: SyntheticEvent) => void;
  submitting: boolean;
  formProps: {
    bikeId: string;
    newOwnerId: string;
    transferDate: string;
  };
}

const BikeOwnershipTransferForm = (props: Props): JSX.Element => {
  const { onSubmit, handleChange, submitting, formProps } = props;
  const { bikeId, newOwnerId, transferDate } = formProps;
  return (
    <Form submitting={submitting} onSubmit={onSubmit}>
      <div className="body-card">
        <Input
          onChange={handleChange}
          label="Bike id*"
          type="text"
          name="bikeId"
          value={bikeId}
          placeholder="Bike id"
          required
        ></Input>
        <Input
          onChange={handleChange}
          label="New owner id*"
          type="text"
          name="newOwnerId"
          value={newOwnerId}
          placeholder="New owner id"
          required
        ></Input>
        <Input
          onChange={handleChange}
          label="Transfer date*"
          type="date"
          name="transferDate"
          value={transferDate}
          required
        ></Input>
      </div>
    </Form>
  );
};

export default BikeOwnershipTransferForm;
